import { render, staticRenderFns } from "./PxCamposCompraViewM8.vue?vue&type=template&id=516840d5&"
import script from "./PxCamposCompraViewM8.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraViewM8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports